var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManchesterOriginalsSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 174.7 201.3",
    style: {
      enableBackground: "new 0 0 174.7 201.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n        .mo-st0{fill:#FFFFFF;}\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mo-st0",
    d: "M174.7,50.3L87.3,0L0,50.3V151l87.3,50.3l87.3-50.3V50.3L174.7,50.3z M87.3,180.8l-25.6-14.7l60.9-73.7 l-32.6,86.9L87.3,180.8L87.3,180.8z M74.8,122.4l33.6-89.7l27.4,15.8L74.8,122.4L74.8,122.4z M87.3,20.5l2.7,1.6l-72.3,87.6V60.6 C17.8,60.6,87.3,20.5,87.3,20.5z M17.8,137.6L76.9,66l-33.5,89.5l-25.6-14.7L17.8,137.6L17.8,137.6z M156.9,140.7l-42.6,24.6 L154.1,59l2.8,1.6L156.9,140.7L156.9,140.7z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManchesterOriginalsSymbol);
export default __webpack_public_path__ + "static/media/manchester-originals-symbol.7acbe47d.svg";
export { ForwardRef as ReactComponent };